import React from "react";

function Loading() {
  return (
    <div>
      <span> Loading Data Please Wait....</span>
    </div>
  );
}

export default Loading;
